import { createRouter, createWebHistory } from "vue-router";
import LoginView from "../views/LoginView.vue";
import MatchView from "../views/MatchView.vue";
import CertView from "../views/CertView.vue";
import BenefitsView from "../views/BenefitsView.vue";
import AdminView from "../views/AdminView.vue";
import ChecklistForm from "../views/ChecklistForm.vue";

function isLoggedIn(): boolean {
  return !!localStorage.getItem("rc_token");
}

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "home",
      component: MatchView,
      meta: { requiresAuth: true }
    },
    {
      path: "/cert",
      name: "cert",
      component: CertView,
      meta: { requiresAuth: true }
    },
    {
      path: "/benefits",
      name: "benefits",
      component: BenefitsView,
      meta: { requiresAuth: true }
    },
    {
      path: "/admin",
      name: "admin",
      component: AdminView,
      meta: { requiresAuth: true, requiresAdmin: true }
    },
    {
      path: "/checklist/:token",
      name: "checklist",
      component: ChecklistForm,
      meta: { requiresAuth: true }
    },
    {
      path: "/login",
      name: "login",
      component: LoginView
    }
  ]
});

router.beforeEach((to, _from, next) => {
  if (to.meta.requiresAuth && !isLoggedIn()) {
    next({ name: "login" });
  } else if (to.name === "login" && isLoggedIn()) {
    next({ name: "home" });
  } else {
    next();
  }
});
